// extracted by mini-css-extract-plugin
module.exports = {"QuestionRow":"ExQuestions_QuestionRow__1fU79","QuestionText":"ExQuestions_QuestionText__2-iYO","QuestionAnswers":"ExQuestions_QuestionAnswers__2x54y"};